import { DELETE, GET, POST } from "@/utils/http";

const ADMIN_BASE_URI = "/transcoder";

export const ConversionRecordService = {
  search(
    request: SearchContactRequest,
  ): Promise<Record<string, any> | null | undefined> {
    return POST<Record<string, any>>(`${ADMIN_BASE_URI}/search`, request);
  },
  download(params: any) {
    return GET<Blob>(`${ADMIN_BASE_URI}/download`, {
      params,
      responseType: "blob",
    });
  },
  delete(syncRecordId: number): Promise<SuccessResponse | null | undefined> {
    return DELETE<SuccessResponse>(
      `${ADMIN_BASE_URI}/delete/${syncRecordId}`,
      undefined,
      true,
    );
  },
};
